export interface CronJobSummaryDTO {
  name: string;
  namespace: string;
  schedule: string;
  lastScheduleTime: string;
  suspended: boolean;
  activeJobCount: number;
  creationTimestamp: string;
}

export interface JobExecutionDTO {
  jobName: string;
  startTime: string;
  completionTime: string;
  status: string;
  readyPods: number;
  totalPods: number;
}

export interface CronJobDetailDTO {
  name: string;
  namespace: string;
  schedule: string;
  lastScheduleTime: string;
  suspended: boolean;
  activeJobCount: number;
  creationTimestamp: string;
  labels: { [key: string]: string };
  recentExecutions: JobExecutionDTO[];
}

export interface TriggerJobResponse {
  jobName: string;
  createdAt: string;
}

export interface SuspendRequest {
  suspend: boolean;
}

export interface UpdateScheduleRequest {
  cronExpression: string;
}

export interface ApiResponseCronJobSummaryList {
  data: CronJobSummaryDTO[];
  dataList: CronJobSummaryDTO[][];
  error: string;
}

export interface ApiResponseCronJobDetail {
  data: CronJobDetailDTO;
  dataList: CronJobDetailDTO[];
  error: string;
}

export interface ApiResponseTriggerJob {
  data: TriggerJobResponse;
  dataList: TriggerJobResponse[];
  error: string;
}

export interface ApiResponseString {
  data: string;
  dataList: string[];
  error: string;
}

export function emptyCronJobSummaryList(): CronJobSummaryDTO[] {
  return [];
}

export function emptyCronJobDetail(): CronJobDetailDTO {
  return {
    name: '',
    namespace: '',
    schedule: '',
    lastScheduleTime: null,
    suspended: false,
    activeJobCount: 0,
    creationTimestamp: null,
    labels: {},
    recentExecutions: []
  };
}
